<template>
    <v-app id="app">
        <template v-if="layout">
            <keep-alive>
                <component v-bind:is="layout">
                </component>
            </keep-alive>
        </template>
    </v-app>
</template>

<style lang="scss">
    #app {
        font-family: 'Roboto', Helvetica, Arial, sans-serif;
        font-size: 14px;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #fff;
    }

    #nav {
        padding: 30px;

        a {
            font-weight: bold;
            color: #2c3e50;

            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }
</style>


<script>

    import SelectCitiesLayout from "./views/layouts/selectCities"

    export default {
        data() {
            return {
                layout: null,
                appOnLine: null

            }
        },
        components: {
            SelectCitiesLayout,
        },
        watch: {
            "$route.meta.layout": {

                handler: function (newVal) {

                    if(newVal){
                        this.layout = (newVal || "Application") + "Layout"
                    }else{
                        this.layout= null
                    }
                },
                deep: true,
                immediate: true


            }

        },
        created(){
            let vh = window.innerHeight * 0.01;
            this.$nextTick(() => {
                document.documentElement.style.setProperty('--vh', `${vh}px`);

            })
            window.addEventListener('resize', () => {
                this.$nextTick(() => {
                    document.documentElement.style.setProperty('--vh', `${vh}px`);

                })
            });

        }
    }
</script>
